"use client";

import { Streamdown } from "streamdown";
import { components } from "../markdown";
import { mathPlugin } from "../lib/markdown-config";
import { getMessageContent } from "../lib/message-utils";
import { ChatRenderProvider } from "../lib/render-context";
import type { T_AssistantMessage } from "../types";

export default function AssistantMessage({
  content,
  isStreaming = false,
}: {
  content: T_AssistantMessage;
  isStreaming?: boolean;
}) {
  return (
    <ChatRenderProvider isStreaming={isStreaming}>
      <Streamdown components={components} plugins={{ math: mathPlugin }}>
        {getMessageContent(content)}
      </Streamdown>
    </ChatRenderProvider>
  );
}
